class _IconManager {
  sheetWidth: number;
  sheetHeight: number;

  constructor() {
    this.sheetWidth = 13;
    this.sheetHeight = 13;
  }

  getItemIcon(item: any) {
    const itemData = GDM.getNow('item_data');
    let data = itemData.getData(item.itemType, item.itemNo);
    let iconId = data[9];

    let sheet = 1 + Math.floor(iconId / (this.sheetWidth * this.sheetHeight));
    let col = iconId % this.sheetWidth;
    let row = Math.floor(iconId / this.sheetHeight) % this.sheetHeight;
    let className = 'item-iconsheet-' + sheet;

    let html = '<div class="icon ' + className + '" style="';
    html += 'background-position: ' + (col * -40) + 'px ' + (row * -40) + 'px; ';
    html += '">';

    if (ITMSTACKABLE[item.itemType] && item.quantity !== 1) {
      html += '<div class="quantity">' + item.quantity + '</div>';
    }

    // Socket (SOKET.png) at the top-left, with the socketed gem's mark
    // (LIST_JEMITEM col 20 -> SOKETJAM.TSI sprite, 4x4 grid of 20px) on top.
    if (item.socketCount > 0) {
      html += '<div class="socket">';
      if (item.gemOption1 > 0) {
        const mark = itemData.getGemStats(item.gemOption1).markImage;
        html += '<div class="socket-gem" style="background-position: ' +
          ((mark % 4) * -20) + 'px ' + (Math.floor(mark / 4) * -20) + 'px;"></div>';
      }
      html += '</div>';
    }

    html += '</div>';
    return $(html);
  }

  getCommandIcon(command: any) {
  }

  getSkillIcon(skill: any) {
    const skillData = GDM.getNow('skill_data');
    const data = skillData.getData(skill.skillIdx);
    const iconId = data[51];

    const sheet = 1 + Math.floor(iconId / (this.sheetWidth * this.sheetHeight));
    const col = iconId % this.sheetWidth;
    const row = Math.floor(iconId / this.sheetHeight) % this.sheetHeight;
    const className = 'skill-iconsheet-' + sheet;

    let html = '<div class="icon ' + className + '" style="';
    html += 'background-position: ' + (col * -40) + 'px ' + (row * -40) + 'px; ';
    html += '">';
    const rank = Number(data[2]);
    if (Number.isInteger(rank) && rank > 0) {
      html += '<span class="skill-rank">Lv.' + rank + '</span>';
    }
    html += '</div>';
    return $(html);
  }

  getEmoteIcon(emote: any) {
  }

  getDialogIcon(dialog: any) {
  }

  getClanSkillIcon(skill: any) {
  }
}

const IconManager = new _IconManager();
export { IconManager };
